import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getExpandedItems } from "../../utils/outbound-labels-utils";
import { StringListCell } from "../cells/string-list-cell";

const catalogEntry = fgColumnEntries.bin;

export const BinColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    const bins = new Set(
      row.lineItemLocations?.flatMap(
        (l) =>
          l.bins?.map((b) =>
            b.quantity ? `${b.bin} (${b.quantity})` : b.bin,
          ) ?? [],
      ) ?? [],
    );
    const sortedBins = Array.from(bins)
      .filter((bin): bin is string => typeof bin === "string")
      .sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" }),
      );
    return <StringListCell displayName="bin" strings={sortedBins} />;
  },
  width: catalogEntry.defaultWidth,
  alignment: ColumnAlignment.LEFT,
  sort: catalogEntry.sortDirection,
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => {
    return (
      <RedoTableTextCell
        text={getExpandedItems(row)?.[expansionIndex]?.bin ?? ""}
      />
    );
  },
};
